module.exports = __webpack_public_path__ + "static/img/video.1eb20ae3.png";